module.exports = __webpack_public_path__ + "img/4.ecd8fce5.png";